import { AugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import { useLocation, useParams } from "react-router-dom"
import { ManageRegistrationContainer } from "../../registration/ManageRegistration"

function ProfileRegistrationConfigureAugmentation() {
  const { registrationId, cohortId } = useParams<{
    registrationId: string
    cohortId?: string
  }>()
  const location = useLocation()
  const cohortQueryParam = new URLSearchParams(location.search).get("cohort")
  const groupId = parseInt((cohortId || cohortQueryParam)!)

  return (
    <AugmentationPanelLegacyForm cardFieldPadding>
      <ManageRegistrationContainer
        // @ts-expect-error: ManageRegistration does expect registrationId
        registrationId={parseInt(registrationId)}
        groupId={groupId}
      />
    </AugmentationPanelLegacyForm>
  )
}

export default ProfileRegistrationConfigureAugmentation
